module.exports = __webpack_public_path__ + "img/chopsticks.05cc5bbb.png";